import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitVisualReactionAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitVisualReactionAssessmentResultInput;
}>;


export type SubmitVisualReactionAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitVisualReactionAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitVisualReactionAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & VisualReactionAssessmentResultFragment
    )> }
  ) }
);

export type VisualReactionAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'CardioRespResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | (
    { __typename: 'VisualReactionResult' }
    & VisualReactionAssessmentResultDataFragment
  ) }
);

export type VisualReactionAssessmentResultDataFragment = (
  { __typename: 'VisualReactionResult' }
  & Pick<SchemaTypes.VisualReactionResult, 'correctAnswers' | 'incorrectAnswers' | 'fastestResponseTimeMs' | 'averageResponseTimeMs' | 'accuracy'>
  & { rounds: Array<(
    { __typename: 'VisualReactionRoundResult' }
    & Pick<SchemaTypes.VisualReactionRoundResult, 'accuracyPerRound' | 'averageResponseTimeMsPerRound'>
    & { questions: Array<(
      { __typename: 'VisualReactionQuestionResult' }
      & Pick<SchemaTypes.VisualReactionQuestionResult, 'isCorrect' | 'responseTimeMs' | 'errorType'>
    )> }
  )> }
);

export const VisualReactionAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment VisualReactionAssessmentResultData on VisualReactionResult {
  rounds {
    questions {
      isCorrect
      responseTimeMs
      errorType
    }
    accuracyPerRound
    averageResponseTimeMsPerRound
  }
  correctAnswers
  incorrectAnswers
  fastestResponseTimeMs
  averageResponseTimeMs
  accuracy
}
    `;
export const VisualReactionAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment VisualReactionAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on VisualReactionResult {
      ...VisualReactionAssessmentResultData
    }
  }
  createdAt
}
    `;
export const SubmitVisualReactionAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitVisualReactionAssessmentResult($input: SubmitVisualReactionAssessmentResultInput!) {
  submitVisualReactionAssessmentResult(input: $input) {
    ... on SubmitVisualReactionAssessmentResultSuccessfulResponse {
      result {
        ...VisualReactionAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${VisualReactionAssessmentResultFragmentDoc}
${VisualReactionAssessmentResultDataFragmentDoc}`;
export type SubmitVisualReactionAssessmentResultMutationFn = Apollo.MutationFunction<SubmitVisualReactionAssessmentResultMutation, SubmitVisualReactionAssessmentResultMutationVariables>;

/**
 * __useSubmitVisualReactionAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitVisualReactionAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVisualReactionAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVisualReactionAssessmentResultMutation, { data, loading, error }] = useSubmitVisualReactionAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitVisualReactionAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitVisualReactionAssessmentResultMutation, SubmitVisualReactionAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitVisualReactionAssessmentResultMutation, SubmitVisualReactionAssessmentResultMutationVariables>(SubmitVisualReactionAssessmentResultDocument, options);
      }
export type SubmitVisualReactionAssessmentResultMutationHookResult = ReturnType<typeof useSubmitVisualReactionAssessmentResultMutation>;
export type SubmitVisualReactionAssessmentResultMutationResult = Apollo.MutationResult<SubmitVisualReactionAssessmentResultMutation>;
export type SubmitVisualReactionAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitVisualReactionAssessmentResultMutation, SubmitVisualReactionAssessmentResultMutationVariables>;